import { handleActions } from 'redux-actions';
import {
  SNACKBAR_OPEN,
  SNACKBAR_CLEAR
} from '../actions/ui';


const defaultState = { snackbarOpen: false };

export default handleActions({
  [SNACKBAR_OPEN]: (state, action) => {
    return {
      snackbarOpen: true,
      message: action.payload.message,
      severity: action.payload.severity || 'success'
    };
  },
  [SNACKBAR_CLEAR]: (state, action) => {
    return {
      snackbarOpen: false
    };
  },
}, defaultState)

